import Scene from '@scene';
import { setSafetyBarrierDimensions } from '@reducers/selectors/dimension/actions';

export const SET_BARRIER_DPOT = 'SET_BARRIER_DPOT';
export const SET_BARRIER_HEIGHT = 'SET_BARRIER_HEIGHT';
export const SET_BARRIER_SHAPE = 'SET_BARRIER_SHAPE';
export const SET_BARRIER_OPTIONS = 'SET_BARRIER_OPTIONS';
export const SET_BARRIER_LOADS_EXTERNAL = 'SET_BARRIER_LOADS_EXTERNAL';
export const SET_BARRIER_LOADS_INTERNAL = 'SET_BARRIER_LOADS_INTERNAL';

export const RESET_BARRIER = 'RESET_BARRIER';
export const SET_BARRIER_STATE = 'SET_BARRIER_STATE';

/*
  Action creators
 */
export function setBarrierDPOT (value) {
  return (dispatch) => {
    dispatch(setSafetyBarrierDimensions({
      dpot: value
    }));
    dispatch(triggerUpdate({ type: SET_BARRIER_DPOT, value }));
  };
}
export function setBarrierHeight (value) {
  return (dispatch) => {
    dispatch(setSafetyBarrierDimensions({
      hgc: value
    }));
    dispatch(triggerUpdate({ type: SET_BARRIER_HEIGHT, value }));
  };
}
export function setBarrierShape (value) {
  return (dispatch, getState) => {
    dispatch({ type: SET_BARRIER_SHAPE, value });

    Scene.updateBarrier(getState().options.barrier);
  };
}
export function setBarrierOptions (options) {
  return (dispatch) => {
    if (options.hasOwnProperty('height')){
      dispatch(setBarrierHeight(options.height));
    }
    if (options.hasOwnProperty('dpot')){
      dispatch(setBarrierDPOT(options.dpot));
    }
    else {
      dispatch(triggerUpdate({ type: SET_BARRIER_OPTIONS, options }));
    }
  };
}
export function setBarrierLoadsExternal (value, isCustom) {
  return (dispatch, getState) => {
    dispatch({ type: SET_BARRIER_LOADS_EXTERNAL, value, isCustom });

    Scene.updateBarrier(getState().options.barrier);
  };
}
export function setBarrierLoadsInternal (value, isActive) {
  return (dispatch, getState) => {
    dispatch({ type: SET_BARRIER_LOADS_INTERNAL, value, isActive });

    Scene.updateBarrier(getState().options.barrier);
  };
}

export function resetBarrier(){
  return triggerUpdate({ type: RESET_BARRIER });
}

export function setBarrierState(state) {
  return { type: SET_BARRIER_STATE, state };
}

function triggerUpdate(event) {
  return (dispatch, getState) => {
    dispatch(event);
    Scene.updateBarrier(getState().options.barrier);
  };
}



// WEBPACK FOOTER //
// ./src/reducers/options/barrier/actions.js